import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const emailRef = useRef();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  async function forgotPassword(email) {
    const response = await fetch(
      "https://social-media-server-414e76d9eb8b.herokuapp.com/api/flyer-generator/request-password-reset",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to send reset email");
    }
    return await response.json();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const email = emailRef.current.value;

    try {
      setLoading(true);
      setError("");
      setMessage("");
      await forgotPassword(email);
      setMessage("Check your email for a reset link, it may be in your spam folder and take a few minutes to arrive");
      emailRef.current.value = "";
    } catch {
      setError("Error Resetting Password");
    }
    setLoading(false);
  }
  return (
    <>
      <div className="h-screen flex flex-col justify-start py-12 sm:px-6 lg:px-8 bg-gray-100">
        <div className="sm:mx-auto sm:w-full sm:max-w-md mt-20">
          <img
            className="mx-auto h-auto w-80 mb-12"
            src="https://onetrustmarketing.com/assets/img/OneTrustFamilyOfCompanies.png"
            alt="OneTrust Marketing"
          />
          {/* <h2 className="mt-6 text-center text-4xl font-extrabold text-teal-400">
            Login
          </h2> */}
        </div>

        <div className="mt-0 sm:mx-auto sm:w-full sm:max-w-md">
          {error && <p className="text-red-500 text-center">{error}</p>}
          {message && (
            <div>
              <p className="text-green-700 text-center mb-0">
                Check your email for the reset link. <strong>It might take a few minutes to arrive</strong> and could be
                in your spam folder.
              </p>
              <p className="text-green-700 text-center">
                If you do not receive an email, please reach out to{" "}
                <a href="mailto:marketing@onetrusthomeloans.com" className="text-green-800 hover:underline">
                  marketing@onetrusthomeloans.com
                </a>
              </p>
            </div>
          )}

          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    ref={emailRef}
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-primary focus:border-blue-primary sm:text-sm"
                  />
                </div>
              </div>
              <div>
                <button
                  disabled={loading}
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-primary hover:bg-blue-complimentary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-primary"
                >
                  Reset Password
                </button>
              </div>
            </form>
          </div>
          <div className="text-sm mt-3">
            <Link to="/login" className="font-medium text-blue-primary hover:text-blue-complimentary">
              Have an account Login?
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
